/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";

import { ImageFormats } from "@repo/design-system/components/forms/libs";
import {
  Iconify, Button, ButtonSize,
  ButtonVariant
} from "@repo/design-system/components/ui";
import ImagePreview from './imagePreview/ImagePreview';

import "./ImageUpload.scss";


const ImageUpload = ({
  name = "",
  onClear,
  onChange,
  placeholder,
  fieldSetting,
  onClearAllImages,
  onActionClick,
  isDownloadButton,
  isViewButton = true,
  onView,
  isMultipleImageAllowed,
  isCircularPreview = false,
  selectedImagePreviews = [],
  acceptedImageFormats = ImageFormats.ANY,
}) => {
  const [imagePreviews, setImagePreviews] = useState(selectedImagePreviews);
  const [zoom, setZoom] = useState(1);

  const fileRef = useRef();

  const handleInputChange = (e) => {
    if (e.target.files?.length > 0) {
      onChange?.(e);
    } else {
      handleClearAll();
    }
  };

  const handleClearClick = (index) => {
    if (index !== undefined) {
      if (onClear) onClear(index);
    }
  };

  const handleDownloadClick = () => {
    onActionClick?.("DOWNLOAD");
  };

  const handleClearAll = () => {
    fileRef.current.value = null;
    setImagePreviews([]);
    setZoom(1);
    onClearAllImages?.();
  };

  useEffect(() => {
    if (selectedImagePreviews?.length > 0 && Array.isArray(selectedImagePreviews)) {
      setImagePreviews(selectedImagePreviews);
      setZoom(1);
    } else {
      setImagePreviews([]);
      handleClearClick();
    }
  }, [selectedImagePreviews]);

  const showCircularView = isCircularPreview && !isMultipleImageAllowed && imagePreviews?.length > 0;

  return (
    <>
      {!showCircularView && (
        <div className="image-upload-container">
          <input ref={fileRef} id={name} name={name} type="file"
            className={`image-input ${!isMultipleImageAllowed && imagePreviews?.length > 0 ? "disabled" : ""}`}
            onChange={handleInputChange} accept={acceptedImageFormats.join(",")}
            multiple={isMultipleImageAllowed}
            disabled={!isMultipleImageAllowed && imagePreviews?.length > 0} />

          <div className="upload-box">
            <div className="upload-border">
              <div className="upload-group">
                <div className="upload-icon">
                  <Iconify icon="fluent:camera-add-48-regular" className="button-icon"
                    altText="Upload Image" />
                </div>
                <p className="upload-text">{placeholder || "Upload images"}</p>
              </div>
            </div>
            <h6 className="file-info">
              <p>
                Allowed Image formats:{" "}
                <span>{acceptedImageFormats.join(", ")}</span>.
              </p>
              <span>
                {fieldSetting?.minImageSizeInMB > 0 &&
                  <>Min <span><b>{fieldSetting?.minImageSizeInMB} MB</b></span> & </>
                }
                Max <span><b>{fieldSetting?.maxImageSizeInMB} MB</b></span>
              </span>
            </h6>
          </div>
        </div>
      )}

      {showCircularView && (
        <div className="single-image-preview">
          <Button className="image-preview__clear-all"
            variant={ButtonVariant.SECONDARY} size={ButtonSize.SM}
            ttLabel="Change Photo" targetId="changePhoto"
            leftIcon="ic:outline-refresh" onClick={handleClearAll}>
          </Button>
          <div className="circular-preview-wrapper">
            <div className="circular-preview">
              <img
                src={imagePreviews[0]}
                alt="Profile preview"
                style={{ transform: `scale(${zoom})` }}
                className="preview-img"
              />
            </div>
          </div>
          {/* <div className="zoom-controls">
            <Iconify icon="mdi:magnify-minus-outline" />
            <input
              type="range"
              min="1"
              max="3"
              step="0.05"
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              className="zoom-slider"
            />
            <Iconify icon="mdi:magnify-plus-outline" />
          </div> */}
          <input ref={fileRef} id={name} name={name} type="file"
            className="image-input-hidden"
            onChange={handleInputChange} accept={acceptedImageFormats.join(",")} />
        </div>
      )}

      {!showCircularView && imagePreviews?.length > 0 && (
        <ImagePreview
          imagePreviews={imagePreviews}
          handleClearAll={handleClearAll}
          onDownload={handleDownloadClick}
          onView={onView}
          handleClearClick={handleClearClick}
          isDownloadButton={isDownloadButton}
          isViewButton={isViewButton}
          isMultipleImageAllowed={isMultipleImageAllowed}
        />
      )}
    </>
  );
};

ImageUpload.propTypes = {
  name: PropTypes.string,
  onClear: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  fieldSetting: PropTypes.shape({
    minImageSizeInMB: PropTypes.number,
    maxImageSizeInMB: PropTypes.number,
  }),
  onClearAllImages: PropTypes.func,
  onActionClick: PropTypes.func,
  isDownloadButton: PropTypes.bool,
  isViewButton: PropTypes.bool,
  onView: PropTypes.func,
  isMultipleImageAllowed: PropTypes.bool,
  isCircularPreview: PropTypes.bool,
  selectedImagePreviews: PropTypes.arrayOf(PropTypes.string),
  acceptedImageFormats: PropTypes.arrayOf(PropTypes.string),
};

export default ImageUpload;
